import { render, staticRenderFns } from "./AdminAdd.vue?vue&type=template&id=d9a88bc2&scoped=true"
import script from "./AdminAdd.vue?vue&type=script&lang=js"
export * from "./AdminAdd.vue?vue&type=script&lang=js"
import style0 from "./AdminAdd.vue?vue&type=style&index=0&id=d9a88bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a88bc2",
  null
  
)

export default component.exports